import { render } from "./team.vue?vue&type=template&id=38366fe1&scoped=true&ts=true"
import script from "./team.ts?vue&type=script&lang=ts&external"
export * from "./team.ts?vue&type=script&lang=ts&external"

import "./team.scss?vue&type=style&index=0&id=38366fe1&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38366fe1"]])

export default __exports__